module.exports = __webpack_public_path__ + "img/fslogo.d7b2e83f.png";